import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams, } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { SessionExpiredService } from './session-expired-service';
import { AppConfig } from "../design/app";
import { IAppConfig } from '../core/models/app-config.model';
import { IApiResponse } from '../core/models/api-response.model';
import { GetSetResponse } from '../core/models/getSetResponse.model';

@Injectable({
    providedIn: 'root'
})
export class AdditionalQuestionService {

  appConfig: any;
  baseUrl;
    constructor(private http: HttpClient,
      private _sessionExpiredService: SessionExpiredService) {
      this.appConfig = AppConfig;
      this.baseUrl = this.appConfig.report.baseUrl;
  }


  public getSetReport(reporttype, setid, startdate, enddate, selectedVersion): Observable<any> {
    const apiUrl: string = this.baseUrl + this.appConfig.report.getSetReport;
    const model = { reporttype, setid, startdate, enddate, selectedVersion }
    return this.http.post(apiUrl, model, { responseType: 'arraybuffer' }).pipe(
      map(response => {
        this._sessionExpiredService.resetTimer();
        return new Uint8Array(response);
      }),
      catchError(this.handleError)
    );
  }

    public getSetDropdown(): Observable<any> {
      const apiUrl: string = this.baseUrl + this.appConfig.report.getSet;
      const headers = new HttpHeaders();
      return this.http.get<IApiResponse<GetSetResponse>>(apiUrl, { headers: headers }).pipe(
        map(res => {
          return res.Data;
            }),
            catchError(this.handleError)
        );
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            console.error('An error occurred:', error.error.message);
        } else {
            console.error(
                `Backend returned code ${error.status}, ` +
                `body was: ${error.error}`);
        }
        return throwError(
            'Something bad happened; please try again later.');
    };
}
